import { createContext, useContext } from 'react';

const DashboardActionContext = createContext(/** @type {useDashboardActionReturn | null} */ (null));

/**
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @param {useDashboardActionReturn} props.value
 * @returns {JSX.Element}
 */
export function DashboardActionProvider({ children, value }) {
  return (
    <DashboardActionContext.Provider value={value}>
      {children}
    </DashboardActionContext.Provider>
  );
}

/**
 * @returns {useDashboardActionReturn}
 */
export function useDashboardActionContext() {
  const context = useContext(DashboardActionContext);
  if (!context) {
    throw new Error('useDashboardActionContext must be used within DashboardActionProvider');
  }
  return context;
}

/**
 * Optional hook for views that may render outside DashboardActionProvider (e.g. Storybook)
 * @returns {useDashboardActionReturn | null}
 */
export function useDashboardActionContextOptional() {
  return useContext(DashboardActionContext);
}
